var _rect, _rect2, _rect3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3154_104)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3154_104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3154_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.7875L12.425 15.7125L13.25 14.8875L14.4875 16.125L16.7875 13.8125L17.6125 14.6625L14.5 17.7875ZM9.9625 14.95L9.1375 14.125L10.025 13.2375L9.1375 12.35L9.9625 11.525L10.85 12.4125L11.7375 11.525L12.5625 12.35L11.675 13.2375L12.5625 14.125L11.7375 14.95L10.85 14.0625L9.9625 14.95ZM7.1875 17.3125V7.42505H9.065V6.67505H10.0875V7.42505H13.9125V6.67505H14.94V7.42505H16.825V12.725L15.6375 13.925V10.875H8.3625V16.1375H11.775L12.95 17.3125H7.1875ZM8.3625 10.125H15.6375V8.61255H8.3625V10.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3154_104",
    x1: 2.35664,
    y1: 2.41273,
    x2: 21.544,
    y2: 22.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3E27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceNew);
export default __webpack_public_path__ + "static/media/attendance_new.2641628c54de7bca427df70f8441dd5f.svg";
export { ForwardRef as ReactComponent };